import React from "react";
import Button from "../atoms/Button/Button"; // Ensure this Button component is imported correctly
import {
  ButtonWrapper,
  SuccessIcon,
  SuccessMessageText,
  SuccessModalWrapper,
  SuccessTitle,
} from "./styles";

interface SuccessModalProps {
  successMessage: string;
  onClose: () => void;
}

const SuccessModalContent: React.FC<SuccessModalProps> = ({
  successMessage,
  onClose,
}) => {
  return (
    <SuccessModalWrapper>
      <SuccessTitle>
        <SuccessIcon />
        SUCCESS
      </SuccessTitle>
      <SuccessMessageText>{successMessage}</SuccessMessageText>
      <ButtonWrapper>
        <Button onClick={onClose}>Close</Button>
      </ButtonWrapper>
    </SuccessModalWrapper>
  );
};

export default SuccessModalContent;
